// extracted by mini-css-extract-plugin
export default {"heading__gray":"Title_heading__gray__woJsd"};